// @flow
import styled from 'styled-components';
import DefaultTheme from '.';
import SelectInputTheme from '../input/theme';
import SelectMultiInputTheme from '../multi-input/theme';
import { errorText, se300 } from '../../colors';
import FormElementSECTheme from '../../form-element/theme/shipa-ecommerce';
import InputSECTheme from '../../input/theme/shipa-ecommerce';
import ItemSECTheme from '../item/theme/shipa-ecommerce';
/*::
import type { SelectThemeType } from '.';
*/

var theme
/*: SelectThemeType */
= Object.assign({}, DefaultTheme, {
  Input: Object.assign({}, SelectInputTheme, {
    TextInput: Object.assign({}, SelectInputTheme.TextInput, {
      Input: styled(SelectInputTheme.TextInput.Input).withConfig({
        displayName: "shipa-ecommerce__Input",
        componentId: "sc-1wjx4zv-0"
      })(["&:focus{border-bottom:1px solid ", ";}"], function (pr) {
        return pr.error ? errorText() : se300();
      })
    })
  }),
  MultiInput: Object.assign({}, SelectMultiInputTheme, {
    TextInput: Object.assign({}, SelectMultiInputTheme.TextInput, {
      Input: styled(SelectMultiInputTheme.TextInput.Input).withConfig({
        displayName: "shipa-ecommerce__Input",
        componentId: "sc-1wjx4zv-1"
      })(["&:focus{border-bottom:1px solid ", ";}"], function (pr) {
        return pr.error ? errorText() : se300();
      })
    })
  }),
  Item: ItemSECTheme,
  OthersInputFormElement: FormElementSECTheme,
  OthersInput: InputSECTheme
});
export default theme;